export const colors = {
  darkGray: "#555",
  lightGray: "#939493",
  lightGreen: "#00c300",
  lineWhite: "#fff",
  lineGreen: "#00c300"
};

export const navigationBarHeight = "200px";
